<template>
  <div
    class="inline-flex rounded-lg overflow-hidden"
    :style="{ borderStyle: 'solid', borderWidth: '1px', borderColor: primaryColor, width: 'fit-content' }"
  >
    <label v-for="(option, index) in options" :key="index" class="relative cursor-pointer mb-0">
      <input
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        @change="handleChange"
        class="sr-only"
      />
      <div
        :class="[
          ' h-full py-2 font-medium text-sm uppercase',
          'transition-all duration-200 ease-in-out',
          'hover:opacity-80',
          {
            'border-l-2': index > 0,
            'bg-white hover:bg-gray-50': modelValue !== option.value,
          },
        ]"
        :style="{
          backgroundColor: modelValue === option.value ? primaryColor : 'white',
          color: modelValue !== option.value ? primaryColor : 'white',
          borderLeftColor: index > 0 ? primaryColor : 'transparent',
          width: '100px',
          display: 'flex',
          justifyContent: 'center',
        }"
      >
        {{ option.text }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonGroup',
  props: {
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    modelValue: {
      type: String,
      required: true,
    },
    primaryColor: {
      type: String,
      required: false,
      default: '#007bff',
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>
<style lang="css"></style>
